'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;
// import { isLoaded as isInfoLoaded, load as loadInfo } from 'redux/modules/info';
// import thumbnail from 'assets/img/home/thumbnail.png';

// import { InfoBar } from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _address = require('redux/modules/address');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reduxAsyncConnect = require('redux-async-connect');

var _localStorage = require('../../utils/localStorage');

var _ScrollButton = require('../../components/ScrollButton/ScrollButton');

var _ScrollButton2 = _interopRequireDefault(_ScrollButton);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Images from 'helpers/Images';
// import window from 'global/window';
var AppDesktop = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    var pathname = getState() && getState().routing && getState().routing.locationBeforeTransitions && getState().routing.locationBeforeTransitions.pathname || '/';
    if (!(0, _setup.isLoaded)(getState())) {
      promises.push(dispatch((0, _setup.loadCatServer)()));
    }
    if (!(0, _setup.isSeoLoaded)(getState()) && pathname.indexOf('upload') === -1) {
      promises.push(dispatch((0, _setup.loadSeo)(pathname)));
    }
    if (!(0, _address.isLoaded)(getState())) {
      promises.push(dispatch((0, _address.loadProvinceServer)()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    lBT: state.routing.locationBeforeTransitions,
    userLocation: state.user.coords,
    pathname: state.setup.pathname,
    pathSeo: state.setup.pathSeo,
    categories: state.setup.categories
  };
}, (0, _extends3.default)({}, filterActions, userActions, authActions, {
  loadCat: setupActions.loadCat,
  pushState: _reactRouterRedux.push,
  setPathName: _setup.setPathName
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AppDesktop, _Component);

  function AppDesktop(props) {
    (0, _classCallCheck3.default)(this, AppDesktop);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AppDesktop.__proto__ || (0, _getPrototypeOf2.default)(AppDesktop)).call(this, props));

    _this.state = {
      showPopupImage: true,
      home: _this.props.location && _this.props.location.pathname === '/' ? true : false
    };

    _this.onClosePopupImage = function () {
      var dateNow = (0, _moment2.default)().format('YYYY-MM-DD');
      (0, _localStorage.localStore)().set('popUpImageHiddenDate', dateNow);
      _this.setState({ showPopupImage: false });
      _this.popUpImageHidden = true;
    };

    _this.popUpImageHidden = false;
    var popUpImageDate = (0, _localStorage.localStore)().get('popUpImageHiddenDate');
    if (popUpImageDate) {
      var now = (0, _moment2.default)().format('YYYY-MM-DD');
      if (now === popUpImageDate) {
        _this.state.showPopupImage = false;
        _this.popUpImageHidden = true;
      }
    }
    return _this;
  }

  (0, _createClass3.default)(AppDesktop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // TODO chỉnh lại login fb desktop/mobile
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: _config2.default.fbAppId,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v3.0'
        });
        window.FB.Event.subscribe('auth.statusChange', function (response) {
          if (response.authResponse) {
            _this2.props.loginFacebook(response.authResponse.accessToken);
          } else {
            // this.updateLoggoutState();
          }
        });
      };
      (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
      // TODO localStore
      if ((0, _localStorage.localStore)().get('token')) {
        this.props.loadAuth();
      }
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(position => {
      //     this.props.saveUserLocation(position.coords);
      //   });
      // }
      if (this.props.user && this.props.pathname && this.props.pathname.indexOf('dang-nhap') === -1 && this.props.pathname.indexOf('register') === -1) {
        this.props.pushState(this.props.pathname);
        this.props.setPathName('');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        this.onRouteChanged();
      }
    }
  }, {
    key: 'onRouteChanged',
    value: function onRouteChanged() {
      var home = this.props.location && this.props.location.pathname === '/' ? true : false;
      if (home !== this.state.home) {
        this.setState({ home: home });
      }
      if (home === true) {
        this.props.changeQuery('');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./AppDesktop.scss');
      var home = this.state.home;
      var _props = this.props,
          location = _props.location,
          pathSeo = _props.pathSeo;
      // TODO SEO

      var currentPath = pathSeo !== '/' ? pathSeo : pathSeo;
      return _react2.default.createElement(
        'div',
        {
          className: location.pathname.indexOf('/kol') === 0 ? styles.appNotContent : styles.app
        },
        _react2.default.createElement(
          _components.Boundary,
          null,
          _react2.default.createElement(_components.HelmetSEO, { path: currentPath, location: location }),
          location.pathname.indexOf('/kol') === 0 ? null : _react2.default.createElement(_components.Header, { location: location, home: home }),
          _react2.default.createElement(
            'div',
            {
              className: styles.appContent + (location.pathname.indexOf('/kol') === 0 ? styles.notContent : '') + (home ? '' : ' ' + styles.notHome)
            },
            this.props.children
          ),
          location.pathname.indexOf('/kol') === 0 ? null : _react2.default.createElement(_components.Footer, null),
          _react2.default.createElement(_ScrollButton2.default, { scrollStepInPx: '50', delayInMs: '16.66' })
        )
      );
    }
  }]);
  return AppDesktop;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object,
  history: _react.PropTypes.object,
  changeQuery: _react.PropTypes.func.isRequired,
  setPathName: _react.PropTypes.func.isRequired,
  lBT: _react.PropTypes.object,
  // saveUserLocation: PropTypes.func,
  userLocation: _react.PropTypes.object,
  pathname: _react.PropTypes.string,
  pathSeo: _react.PropTypes.string,
  loadAuth: _react.PropTypes.func,
  loginFacebook: _react.PropTypes.func,
  categories: _react.PropTypes.array,
  loadCat: _react.PropTypes.func
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = AppDesktop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/AppDesktop.js
// module id = 1660
// module chunks = 0